<template>
  <div>
    <div class="ui inverted segment">
      <div class="ui inverted header">
        {{ localization.consentManagement.studyName }}
        <div class="sub header">
          {{ localization.studyIdentifier.studyIdentifierLabel }}: {{ userStudyIdentifier }}
        </div>
      </div>
      <div v-html="localization.consentManagement.studyDescription"/>
      <br>
      <div
        class="ui tertiary fluid circular button"
        @click="updateConfirmation(true)">
        {{ localization.consentManagement.withdrawConsent }}
      </div>
    </div>

    <div class="ui inverted small segment">
      {{ localization.consentManagement.contactInfo }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: '',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['userStudyIdentifier'])
  },
  methods: {
    updateConfirmation (val) {
      this.$emit('updateConfirmation', val)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/study/ConsentSuccess.vue